import { Component, Input } from '@angular/core';
import { CourseType } from '@cna/projects/ak-jura/shared/interfaces';

@Component({
    selector: 'cna-dashboard-tile-grid',
    templateUrl: './dashboard-tile-grid.component.html',
    styleUrls: ['./dashboard-tile-grid.component.scss'],
})
export class DashboardTileGridComponent {
    @Input() courseSelected: boolean;
    @Input() courseLocked: boolean;
    @Input() courseType: string;
    @Input() isTest: boolean;

    CourseType = CourseType;
}
